import * as React from 'react';
import styled from 'styled-components';

const Container = styled.div`
	overflow: auto;
	user-select: none;
	-webkit-user-select: none;
	-ms-overflow-style: none;
	& a {
		-webkit-user-drag: none;
	}
	&::-webkit-scrollbar {
		display: none;
	}
`;

const Scroller: React.FC<{ children: React.ReactNode } & React.HTMLAttributes<HTMLDivElement>> = ({
	children,
	...rest
}) => {
	const refContainer = React.useRef<HTMLDivElement | null>(null);

	React.useEffect(() => {
		const container = refContainer.current;

		if (container) {
			let scrollX = 0;
			let mousePosX = 0;

			const mousemoveHandler = (event: MouseEvent) => {
				const deltaX = event.clientX - mousePosX;
				container.scrollLeft = scrollX - deltaX;
			};

			const mouseupHandler = () => {
				document.removeEventListener('mousemove', mousemoveHandler);
				document.removeEventListener('mouseup', mouseupHandler);
			};

			const mousedownHandler = (event: MouseEvent) => {
				scrollX = container.scrollLeft + 100;
				mousePosX = event.clientX;
				document.addEventListener('mousemove', mousemoveHandler);
				document.addEventListener('mouseup', mouseupHandler);
			};

			container.addEventListener('mousedown', mousedownHandler);

			return () => {
				document.removeEventListener('mousemove', mousemoveHandler);
				document.removeEventListener('mouseup', mouseupHandler);
				container.removeEventListener('mousedown', mousedownHandler);
			};
		}

		return () => {};
	}, []);

	return (
		<Container ref={refContainer} {...rest}>
			{children}
		</Container>
	);
};

export default Scroller;
